import axios from 'axios';

export class SetNotiTimeService {
  static getNotiTimeOptions() {
    return axios
      .post(
        '/p/oneapp/client/api/getUserOptions',
        `payload=${JSON.stringify({
          optionNames: ['notiEtiquette'],
        })}`,
      )
      .then(({ data }) => {
        const { userOptions } = data;
        let optionItem = userOptions.find(item => {
          return item.optionName === 'notiEtiquette';
        })

        if(optionItem && optionItem.optionValue){
          const optionValue = JSON.parse(optionItem.optionValue);
          return optionValue;
        }
      });
  }

  static saveNotiTimeOptions(option) {
    return axios
      .post(
        '/p/oneapp/client/api/setEtiquette',
        `payload=${JSON.stringify(option)}`,
      )
      .then(({ data }) => {
        return data.code === 200;
      });
  }
}
